import React, { Component } from "react";
import { Container, Row, Col, Form } from "react-bootstrap"
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from "@mui/material";
import { Tabs, Tab } from "@mui/material";
// import CreatableSelect from 'react-select/creatable';
import { Add } from '@mui/icons-material';
import axios from "axios";
// import Box from '@mui/material/Box';
// import MenuItem from '@mui/material/MenuItem';
// import Checkbox from '@mui/material/Checkbox';
import RemoveIcon from '@mui/icons-material/Delete';
// import { debounceFunc, formatAmount } from './../../helper';
import Select from '../../Components/PCSelect';
import Swal from "sweetalert2";
import PhoneClinicGrid from "../../Components/PhoneClinicGrid";
import RowActions from "../../Components/PhoneClinicGrid/RowActions";
import { formatAmount, parseMoney } from '../../helper';

import AmountInput from '../../Components/AmountInput';
import FormCard from './shared/FormCard';
class CommonPayAccounts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            PayAccountList: [],

            addPayAccount: false,
            isEdit: false,
            ACCOUNT_ID: "",
            ACCOUNT_TITLE: "",
            ACCOUNT_EMAIL: "",
            ACCOUNT_PASSWORD: "",
            OPENING_BALANCE: "",
            OPENING_DATE: "",

            tabValue: 0,
            ShopList: [],
            AllShopData: [],
            ShopPartnerDetail: [],
            ShopCardDetail: []

        }
        this.gridRef = React.createRef(null);
    }

    // componentDidMount() {
    //     let { searchGridData, totalRecordsPerPage, paginationValue } = this.state
    //     this.getPayAccounts(searchGridData, totalRecordsPerPage.value, paginationValue)
    // }

    async getPayAccounts(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };
        const getDevice = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetPayAccount.php`, formData);

        let deviceData = getDevice.data
        let PayAccountList = []


        if (deviceData.success === 1) {
            PayAccountList = deviceData.data
            pagination.totalItems = parseInt(deviceData.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ PayAccountList })
        this.props.toggleLoader(false)
    }

    handleAddPayAccount() {
        this.setState({ addPayAccount: true, isEdit: false })
    }

    handleChangeInput(fieldName, event) {
        let targetValue = event.target.value
        // switch (fieldName) {
        //     default:
        //         targetValue = event.target.value
        //         break;
        // }
        this.setState({ [fieldName]: targetValue })
    }


    handleCancelPayAccount() {
        this.setState({
            addPayAccount: false,
            isEdit: false,
            ACCOUNT_ID: "",
            ACCOUNT_TITLE: "",
            ACCOUNT_EMAIL: "",
            ACCOUNT_PASSWORD: "",
            OPENING_BALANCE: "",
            OPENING_DATE: "",
            ShopPartnerDetail: [],
            ShopCardDetail: [],
        })
    }

    validatePayAccount() {
        const title = (this.state.ACCOUNT_TITLE || "").trim();
        const openingDate = (this.state.OPENING_DATE || "").trim();
        if (!title) {
            Swal.fire('Required', 'Please enter an Account Title.', 'warning');
            return false;
        }
        if (!openingDate) {
            Swal.fire('Required', 'Please select an Opening Date.', 'warning');
            return false;
        }
        /*
         * A partner / card row is INCOMPLETE if ANY of its fields is blank, and an incomplete row
         * BLOCKS the save. It is no longer skipped.
         *
         * Why blocking rather than skipping: PS_FR_WEEK / PS_TO_WEEK / PS_ACC_PRC are NOT NULL
         * varchars, and '' satisfies NOT NULL — so a half-filled row used to be stored happily in
         * pc_part_master / pc_card_master and then read by linking/WeeklySale.php,
         * linking/ShopPaymentUpdate.php and linking/WeeklyDeliveryUpdate.php as though it were a
         * real partnership. Skipping a shopless row also left it sitting in the
         * pc_pay_account.ShopPartnerDetail JSON forever, reappearing in this form on every edit.
         *
         * The same rule is enforced server-side by pc_pa_row_problems() in
         * mutation/PCAddPayAccount.php, so a caller that bypasses this form cannot get past it.
         */
        const blank = (v) => v === "" || v === undefined || v === null;
        const missingFields = (r, needPercentage) => {
            const shop = r && r.ShopName && typeof r.ShopName === 'object' ? r.ShopName.value : (r ? r.ShopName : "");
            const missing = [];
            if (blank(shop)) missing.push('Shop');
            if (blank(r && r.FromDate)) missing.push('From date');
            if (blank(r && r.ToDate)) missing.push('To date');
            if (needPercentage && blank(r && r.Percentage)) missing.push('Percentage');
            return missing;
        };
        // Rows are identified by position, not by shop name — the shop itself may be the blank field.
        const firstIncomplete = (rows, needPercentage, label) => {
            for (let i = 0; i < (rows || []).length; i++) {
                const missing = missingFields(rows[i], needPercentage);
                if (missing.length) return `${label} row ${i + 1} is missing: ${missing.join(', ')}.`;
            }
            return null;
        };
        const incomplete = firstIncomplete(this.state.ShopPartnerDetail, true, 'Partner')
            || firstIncomplete(this.state.ShopCardDetail, false, 'Card');
        if (incomplete) {
            Swal.fire(
                'Incomplete row',
                `${incomplete} Complete it, or remove the row using the red delete button.`,
                'warning'
            );
            return false;
        }
        return true;
    }

    async handleSubmitPayAccount() {
        if (!this.validatePayAccount()) return;
        this.props.toggleLoader(true)
        let formData = {
            ACCOUNT_ID: this.state.ACCOUNT_ID,
            ACCOUNT_TITLE: this.state.ACCOUNT_TITLE,
            OPENING_BALANCE: this.state.OPENING_BALANCE,
            OPENING_DATE: this.state.OPENING_DATE,
            ShopPartnerDetail: JSON.stringify(this.state.ShopPartnerDetail),
            ShopCardDetail: JSON.stringify(this.state.ShopCardDetail),
            PC_USR_EMAIL: "",
            PC_USR_PASS_DECRYPT: "",
            PC_GRP_ID: "4",
            PC_USR_ROLE_ID: "2",
        }

        // let SP_WORKER_LIST = []
        // SP_WORKER_LIST.push({
        //     PC_USR_NAME: this.state.ACCOUNT_TITLE,
        //     PC_USR_EMAIL: this.state.ACCOUNT_EMAIL,
        //     PC_USR_PASS_DECRYPT: this.state.ACCOUNT_PASSWORD,
        //     PC_GRP_ID: "4",
        //     PC_USR_ROLE_ID: "2",
        //     PC_GRP_ATT: this.state.ACCOUNT_ID
        // })
        // :: TODO
        // await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/PCAddUser.php`, SP_WORKER_LIST);

        /* The response is CHECKED now. It used to be discarded, so a refusal from the server —
         * the approval lock, a missing title, the wipe guard below — looked like a successful
         * save: the form closed, the grid refreshed, and nothing had been written.
         *
         * PayAccountUpdate.php rebuilds this account's whole partner history, so it must only
         * run once the save has actually succeeded. */
        let saved = await this.postPayAccount(formData);

        /* The wipe guard (mutation/PCAddPayAccount.php pc_pa_clear_problem). Saving an account
         * DELETEs and re-inserts its partner/card rows, so an empty list means "delete them
         * all". The server refuses that silently-destructive save with CLEAR_CONFIRM_REQUIRED
         * and tells us how many rows are at stake; we name the number and let the user decide.
         * The count comes from the database, not from this screen's state, so it is right even
         * if the form is stale. */
        if (saved && saved.code === 'CLEAR_CONFIRM_REQUIRED') {
            this.props.toggleLoader(false)
            const ok = await Swal.fire({
                title: 'Remove them all?',
                text: saved.message,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, remove them',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#d33',
            });
            if (!ok.isConfirmed) {
                return; // form stays open with the user's edits intact
            }
            this.props.toggleLoader(true)
            saved = await this.postPayAccount({
                ...formData,
                CONFIRM_CLEAR_PARTNERS: !!(saved.confirm && saved.confirm.partners),
                CONFIRM_CLEAR_CARDS: !!(saved.confirm && saved.confirm.cards),
            });
        }

        if (!saved || saved.success !== 1) {
            this.props.toggleLoader(false)
            Swal.fire('Not saved', (saved && saved.message) || 'The account could not be saved.', 'error');
            return; // nothing was written, so do not rebuild history or close the form
        }

        await axios.post(`${process.env.REACT_APP_BASE_URL}services/linking/PayAccountUpdate.php`, { "ACC_ID": this.state.ACCOUNT_ID });
        this.handleCancelPayAccount()
        this.getPayAccounts()
    }

    // One place that posts the account and hands back the parsed body, so the caller can branch
    // on it. A transport failure returns null rather than throwing, and is reported as an error.
    async postPayAccount(formData) {
        try {
            const res = await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/PCAddPayAccount.php`, formData);
            return res && res.data ? res.data : null;
        } catch (e) {
            return null;
        }
    }


    async handleEdit(indx) {
        await this.getShopList();

        let { PayAccountList } = this.state
        this.setState({
            addPayAccount: true,
            isEdit: true,
            ACCOUNT_ID: PayAccountList[indx]['ACCOUNT_ID'],
            ACCOUNT_TITLE: PayAccountList[indx]['ACCOUNT_TITLE'],
            ACCOUNT_EMAIL: PayAccountList[indx]['PC_USR_EMAIL'],
            // Never loaded: stored passwords are no longer sent to the browser (T1.39).
            ACCOUNT_PASSWORD: "",
            OPENING_BALANCE: PayAccountList[indx]['OPENING_BALANCE'],
            OPENING_DATE: PayAccountList[indx]['OPENING_DATE'],
            ShopPartnerDetail: PayAccountList[indx]['ShopPartnerDetail'] ? JSON.parse(PayAccountList[indx]['ShopPartnerDetail']) : [],
            ShopCardDetail: PayAccountList[indx]['ShopCardDetail'] ? JSON.parse(PayAccountList[indx]['ShopCardDetail']) : []
        })
    }

    async getShopList() {
        this.props.toggleLoader(true)
        const getShops = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetShops.php`);
        let shopData = getShops.data
        let ShopList = []
        if (shopData.success === 1) {
            for (let i = 0; i < shopData.data.length; i++) {
                const shop = shopData.data[i];
                ShopList.push({
                    value: shop.PC_SP_ID,
                    label: shop.SP_NAME
                })
            }
        }
        this.setState({ ShopList, AllShopData: shopData.data })
        this.props.toggleLoader(false)
    }

    handleTabChange(evt, val) {
        // if (val === 1) {
        //     await this.getUserList()
        // }
        this.setState({ tabValue: val })
    }

    handleChangeShopPartner(index, fieldName, evt) {
        let { ShopPartnerDetail } = this.state;
        let value;
        if (fieldName === 'ShopName') {
            value = evt;
        } else {
            value = evt.target.value;
        }
        ShopPartnerDetail[index][fieldName] = value
        this.setState({ ShopPartnerDetail })
    }

    handleChangeShopCard(index, fieldName, evt) {
        let { ShopCardDetail } = this.state;
        let value;
        if (fieldName === 'ShopName') {
            value = evt;
        } else {
            value = evt.target.value;
        }
        ShopCardDetail[index][fieldName] = value
        this.setState({ ShopCardDetail })
    }

    handleAddTableItem() {
        let { ShopPartnerDetail } = this.state;
        ShopPartnerDetail.push({
            ShopName: "",
            Percentage: "",
            FromDate: "",
            ToDate: ""
        })
        this.setState({ ShopPartnerDetail })
    }

    handleAddTableItemCard() {
        let { ShopCardDetail } = this.state;
        ShopCardDetail.push({
            ShopName: "",
            FromDate: "",
            ToDate: ""
        })
        this.setState({ ShopCardDetail })
    }

    /*
     * Partner / card row removal.
     *
     * These rows are persisted ONLY on save: mutation/PCAddPayAccount.php deletes every
     * pc_part_master / pc_card_master row for the account and re-inserts from the posted
     * JSON. So dropping a row here IS the delete — there is no server call to make, and
     * nothing is removed until the account is saved.
     */
    rowHasData(row) {
        if (!row) return false;
        const shop = row.ShopName && typeof row.ShopName === 'object' ? row.ShopName.value : row.ShopName;
        const pct = row.Percentage;
        return Boolean(shop) || Boolean(row.FromDate) || Boolean(row.ToDate)
            || (pct !== "" && pct !== undefined && pct !== null);
    }

    removeTableRow(stateKey, idx) {
        const rows = [...(this.state[stateKey] || [])];
        if (idx < 0 || idx >= rows.length) return;
        const drop = () => {
            rows.splice(idx, 1);
            this.setState({ [stateKey]: rows });
        };
        // A row just added by mistake is still blank — do not interrupt for that.
        if (!this.rowHasData(rows[idx])) {
            drop();
            return;
        }
        Swal.fire({
            title: 'Remove this row ?',
            text: 'It will be deleted when you save the account.',
            icon: "question",
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) drop();
        })
    }

    handleRemoveTableItem(idx) {
        this.removeTableRow('ShopPartnerDetail', idx);
    }

    handleRemoveTableItemCard(idx) {
        this.removeTableRow('ShopCardDetail', idx);
    }

    /* Pay Account has NO approval workflow. The status chip, the selection checkboxes, the
     * bulk bar and the per-row Approve / Reject / Reopen buttons were all removed on
     * 2026-10-13 on the user's instruction, together with the server-side edit/delete lock in
     * mutation/PCAddPayAccount.php and delete/setup/DeletePayAccount.php. PA_STATUS,
     * PA_STATUS_BY and PA_STATUS_AT are left on the table (all 27 rows read PENDING, so nothing
     * was locked) in case it is ever wanted back. */

    handleDelete(ACCOUNT_ID) {
        Swal.fire({
            title: 'Do you want to delete account ?',
            icon: "question",
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const getShops = await axios.post(`${process.env.REACT_APP_BASE_URL}services/delete/setup/DeletePayAccount.php`, { ACCOUNT_ID });
                let shopData = getShops.data
                if (shopData.success === 1 && shopData.message === "You have successfully delete track.") {
                    Swal.fire('Account Delete!', '', 'success')
                    this.getPayAccounts()
                }
            }
        })
    }

    render() {
        const { PayAccountList } = this.state;

        return (
            <Container>
                {this.state.addPayAccount === false ?
                    <PhoneClinicGrid
                        title="PAY ACCOUNT"
                        isEditable={true}
                        ref={this.gridRef}
                        buttonLabel="Add Pay Account"
                        getData={this.getPayAccounts.bind(this)}
                        onClickButton={this.handleAddPayAccount.bind(this)}
                        tableHeadData={[
                            {
                                label: "ACCOUNT TITLE",
                                isHidden: false
                            },
                            {
                                label: "BALANCE",
                                isHidden: false
                            },
                            {
                                label: "OPENING DATE",
                                isHidden: false
                            },
                        ]}
                    >
                        {PayAccountList.map((device, idx) => (
                            <TableRow
                                className="table-rows"
                                key={idx}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell align='left' >{device.ACCOUNT_TITLE}</TableCell>
                                {/* parseMoney first: OPENING_BALANCE is a varchar, and anything
                                    stored before the save started normalising it (2026-10-14) may
                                    still carry a thousands separator or a currency symbol.
                                    money() alone renders such a value as 0.00, which read as "the
                                    save did not work" while Account Balance showed the real
                                    figure. */}
                                <TableCell align='left' scope="row" >{formatAmount(parseMoney(device.OPENING_BALANCE))}</TableCell>
                                <TableCell align='left' scope="row" >{device.OPENING_DATE}</TableCell>
                                <TableCell align='center'>
                                    {/* Pay Account carries no approval workflow (removed 2026-10-13 on the user's
                                        instruction), so edit and delete are never gated by a status here. */}
                                    <RowActions actions={[
                                        { type: 'edit', onClick: this.handleEdit.bind(this, idx) },
                                        { type: 'delete', onClick: this.handleDelete.bind(this, device.ACCOUNT_ID) },
                                    ]} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </PhoneClinicGrid>
                    :
                    <>
                        <FormCard title={this.state.isEdit ? 'Edit Pay Account' : 'Add Pay Account'} mode={this.state.isEdit ? 'edit' : 'new'}
                            onCancel={this.handleCancelPayAccount.bind(this)}
                            onSave={this.handleSubmitPayAccount.bind(this)} saveLabel="Save">
                        <Row>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Account Title</Form.Label>
                                    <Form.Control
                                        value={this.state.ACCOUNT_TITLE}
                                        name={"ACCOUNT_TITLE"}
                                        onChange={this.handleChangeInput.bind(this, "ACCOUNT_TITLE")}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Opening Balance</Form.Label>
                                    <AmountInput
                                        value={this.state.OPENING_BALANCE}
                                        name={"OPENING_BALANCE"}
                                        onChange={this.handleChangeInput.bind(this, "OPENING_BALANCE")}

                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Date</Form.Label>
                                    <Form.Control
                                        value={this.state.OPENING_DATE}
                                        name={"OPENING_DATE"}
                                        type="date"
                                        onChange={this.handleChangeInput.bind(this, "OPENING_DATE")}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Group>
                            </Col>
                            {/* <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        value={this.state.ACCOUNT_EMAIL}
                                        name={"ACCOUNT_EMAIL"}
                                        type="email"
                                        autoComplete={"new-email"}
                                        onChange={this.handleChangeInput.bind(this, "ACCOUNT_EMAIL")}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        value={this.state.ACCOUNT_PASSWORD}
                                        name={"ACCOUNT_PASSWORD"}
                                        type="password"
                                        autoComplete={"new-password"}
                                        onChange={this.handleChangeInput.bind(this, "ACCOUNT_PASSWORD")}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Group>
                            </Col> */}
                        </Row>
                        </FormCard>
                    </>
                }
                {this.state.isEdit === true ?
                    (
                        <div>
                            <Tabs value={this.state.tabValue} onChange={this.handleTabChange.bind(this)} aria-label="basic tabs example">
                                <Tab label="Shop Partner" />
                                <Tab label="Shop Card" />
                            </Tabs>
                            {this.state.tabValue === 0 ?
                                <Row style={{
                                    margin: "5px",
                                    height: "75vh",
                                    overflow: "auto",
                                    padding: '10px'
                                }} >
                                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                        <TableContainer sx={{ maxHeight: '70vh' }} style={{ height: '100%' }} >
                                            <Table stickyHeader sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >Shop</TableCell>
                                                        <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >Percentage</TableCell>
                                                        <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >From</TableCell>
                                                        <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >To</TableCell>
                                                        <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >
                                                            <div onClick={this.handleAddTableItem.bind(this)} >
                                                                <Add className="HoverButtonAdd" />
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.ShopPartnerDetail.map((device, idx) => (
                                                        <TableRow
                                                            className="table-rows"
                                                            key={idx}
                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                        >
                                                            <TableCell component="th" scope="row" style={{ cursor: 'pointer' }} >
                                                                <Select menuPortalTarget={document.body}
                                                                    menuPlacement="auto"
                                                                    style={{ height: '32px' }}
                                                                    value={device['ShopName']}
                                                                    options={this.state.ShopList}
                                                                    onChange={this.handleChangeShopPartner.bind(this, idx, 'ShopName')}
                                                                />
                                                            </TableCell>
                                                            <TableCell component="th" scope="row" >
                                                                <Form.Control
                                                                    value={device['Percentage']}
                                                                    onChange={this.handleChangeShopPartner.bind(this, idx, 'Percentage')}

                                                                />
                                                            </TableCell>
                                                            <TableCell component="th" scope="row" >
                                                                <Form.Control
                                                                    type="date"
                                                                    value={device['FromDate'] || ''}
                                                                    onChange={this.handleChangeShopPartner.bind(this, idx, 'FromDate')}
                                                                    style={{ minWidth: 150 }}
                                                                />
                                                            </TableCell>
                                                            <TableCell component="th" scope="row" >
                                                                <Form.Control
                                                                    type="date"
                                                                    value={device['ToDate'] || ''}
                                                                    onChange={this.handleChangeShopPartner.bind(this, idx, 'ToDate')}
                                                                    style={{ minWidth: 150 }}
                                                                />
                                                            </TableCell>
                                                            <TableCell component="th" scope="row" align="center" >
                                                                <IconButton
                                                                    aria-label="Remove partner row"
                                                                    title="Remove this row"
                                                                    size="small"
                                                                    color="error"
                                                                    onClick={this.handleRemoveTableItem.bind(this, idx)}
                                                                >
                                                                    <RemoveIcon fontSize="small" />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Row>
                                :
                                <Row style={{
                                    margin: "5px",
                                    height: "75vh",
                                    overflow: "auto",
                                    padding: '10px'
                                }} >
                                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                        <TableContainer sx={{ maxHeight: '70vh' }} style={{ height: '100%' }} >
                                            <Table stickyHeader sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >Shop</TableCell>
                                                        <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >From</TableCell>
                                                        <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >To</TableCell>
                                                        <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >
                                                            <div onClick={this.handleAddTableItemCard.bind(this)} >
                                                                <Add className="HoverButtonAdd" />
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.ShopCardDetail.map((device, idx) => (
                                                        <TableRow
                                                            className="table-rows"
                                                            key={idx}
                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                        >
                                                            <TableCell component="th" scope="row" style={{ cursor: 'pointer' }} >
                                                                <Select menuPortalTarget={document.body}
                                                                    menuPlacement="auto"
                                                                    style={{ height: '32px' }}
                                                                    value={device['ShopName']}
                                                                    options={this.state.ShopList}
                                                                    onChange={this.handleChangeShopCard.bind(this, idx, 'ShopName')}
                                                                />
                                                            </TableCell>
                                                            <TableCell component="th" scope="row" >
                                                                <Form.Control
                                                                    type="date"
                                                                    value={device['FromDate'] || ''}
                                                                    onChange={this.handleChangeShopCard.bind(this, idx, 'FromDate')}
                                                                    style={{ minWidth: 150 }}
                                                                />
                                                            </TableCell>
                                                            <TableCell component="th" scope="row" >
                                                                <Form.Control
                                                                    type="date"
                                                                    value={device['ToDate'] || ''}
                                                                    onChange={this.handleChangeShopCard.bind(this, idx, 'ToDate')}
                                                                    style={{ minWidth: 150 }}
                                                                />
                                                            </TableCell>
                                                            <TableCell component="th" scope="row" align="center" >
                                                                <IconButton
                                                                    aria-label="Remove card row"
                                                                    title="Remove this row"
                                                                    size="small"
                                                                    color="error"
                                                                    onClick={this.handleRemoveTableItemCard.bind(this, idx)}
                                                                >
                                                                    <RemoveIcon fontSize="small" />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Row>
                            }
                        </div>
                    )
                    :
                    null
                }
            </Container>
        );
    }
}

export default CommonPayAccounts;